export default {
  selectTheDefaultLanguage: 'Select the default language',
  youCanChangeTheDefaultLanguage: 'You can change the language in your profile at any time.',
};
